export interface UpdateFuelSupplierRequest {
  id: number | null;
  name: string;
  stationManager: string;
  address: string;
  sapId: string;
  remarks: string;
}
